import script from "./Badges.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badges.vue?vue&type=script&lang=ts&setup=true"

import "./Badges.vue?vue&type=style&index=0&id=6f00b966&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f00b966"]])

export default __exports__